import { LOCALES, estLocaleGeree, nomDeLaLangue } from '@repere/core';
import { useTraduction } from './langue';

/**
 * Choix de la langue de l'interface.
 *
 * Une liste déroulante et non des boutons comme `ChoixTheme` : trois apparences tiennent
 * en une rangée de boutons, six langues déborderaient le bandeau sur un téléphone où
 * l'apparence, le régime du compte et le compte lui-même se disputent déjà la largeur.
 *
 * Chaque option se nomme elle-même, dans la langue qu'elle désigne — « Deutsch », pas
 * « Allemand » — pour rester lisible à qui ne lit pas encore le français : un parent qui
 * ouvre l'application dans la mauvaise langue doit pouvoir reconnaître la sienne sans
 * l'avoir déjà comprise.
 */
export function ChoixLangue() {
  const { locale, messages, changer } = useTraduction();

  return (
    <select
      className="choix-langue"
      aria-label={messages.langue.selecteur}
      value={locale}
      onChange={(evenement) => {
        const choix = evenement.target.value;
        if (estLocaleGeree(choix)) changer(choix);
      }}
    >
      {LOCALES.map((code) => (
        <option key={code} value={code}>
          {nomDeLaLangue(code, code)}
        </option>
      ))}
    </select>
  );
}
